import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { PatientCdrDocumentDto, PatientCdrDocumentsThatRequireActionDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const patientCdrDocumentsApiUri = `${baseUrl}/api/patient-cdr-documents`;

export const getPatientCdrDocuments = (
    ids: number[],
    source: CancelTokenSource
): Promise<PatientCdrDocumentsThatRequireActionDto> => {

  return axios.get(
          `${patientCdrDocumentsApiUri}`,
          {
            params: {
              ids: ids.join(",")
            },
            cancelToken: source.token
          })
      .then((response) => response.data);
}

export const getPatientCdrDocumentsThatRequireAction = (
    requiresActionOnly: boolean,
    requiresDoctorActionOnly: boolean,
    abnormalFindingOnly: boolean,
    discussWithPatientOnly: boolean,
    noProcedureCreatedOnly: boolean,
    procedureCreatedOnly: boolean,
    fromDate: string | undefined,
    toDate: string | undefined,
    source: CancelTokenSource
): Promise<PatientCdrDocumentsThatRequireActionDto> => {

  const params: { [name: string]: string } = {};
  if (requiresActionOnly) {
    params.requiresActionOnly = `${requiresActionOnly}`;
  }
  if (requiresDoctorActionOnly) {
    params.requiresDoctorActionOnly = `${requiresDoctorActionOnly}`;
  }
  if (abnormalFindingOnly) {
    params.abnormalFindingOnly = `${abnormalFindingOnly}`;
  }
  if (discussWithPatientOnly) {
    params.discussWithPatientOnly = `${discussWithPatientOnly}`;
  }
  if (noProcedureCreatedOnly) {
    params.noProcedureCreatedOnly = `${noProcedureCreatedOnly}`;
  }
  if (procedureCreatedOnly) {
    params.procedureCreatedOnly = `${procedureCreatedOnly}`;
  }
  if (fromDate) {
    params.fromDate = `${fromDate}`;
  }
  if (toDate) {
    params.toDate = `${toDate}`;
  }

  return axios.get(
          `${patientCdrDocumentsApiUri}/action-required`,
          {
            params,
            cancelToken: source.token
          })
      .then((response) => response.data);
}

export const getPatientDocumentsWithProcedureCreatedFalse = (
    fromDate: string | undefined,
    toDate: string | undefined,
    source: CancelTokenSource)
    : Promise<PatientCdrDocumentsThatRequireActionDto> => {

  const params: { [name: string]: string } = {};
  if (fromDate) {
    params.fromDate = `${fromDate}`;
  }
  if (toDate) {
    params.toDate = `${toDate}`;
  }

  return axios.get(
          `${patientCdrDocumentsApiUri}/procedure-created`,
          {
            params,
            cancelToken: source.token
          })
      .then((response) => response.data);
}

export const getUpdatedPatientCdrDocumentDto = (
    documentId: number,
    source: CancelTokenSource)
    : Promise<PatientCdrDocumentDto> => {
  return axios.get(
          `${patientCdrDocumentsApiUri}/${documentId}/action-required`,
          {cancelToken: source.token})
      .then((response) => response.data);
}
